// Mock data for BYMAT Automation LMS — Phase 1
// All data here is for UI scaffolding. Real data comes from backend in Phase 3+.

export const BRAND = {
  name: 'BYMAT Automation',
  tagline: 'Real-Time GenAI Automation Testing Mentorship',
  email: 'support@bymatautomation.com',
  phone: '+91-9076104425',
  whatsapp: 'https://wa.me/919076104425?text=Hi%20Rahul%2C%20I%27m%20interested%20in%20switching%20my%20career%20to%20GenAI%20Automation%20Testing.%20Please%20share%20the%20details!',
  address: '506, Dream SKY CHS, Survey No – 279, Dhanori – Lohagaon Road, Lohagaon, Pune – 411047',
  logoUrl: '/images/logo_image.png',
  founded: 'June 2018',
  founder: 'Rahul Ganjare',
  experience: '18+ Years',
  social: {
    linkedin: 'https://www.linkedin.com/in/rahul-ganjare/',
    youtube: 'https://www.youtube.com/@bymatautomation',
    instagram: 'https://www.instagram.com/bymatautomation/',
  },
  reviews: {
    urbanpro: 'https://www.urbanpro.com/rr/1492667',
    urbanproReviews: 'https://www.urbanpro.com/pune/rahul-ganjare/reviews/13402861?',
    trustpilot: 'https://www.trustpilot.com/evaluate/bymatautomation.com',
    trustpilotReviews: 'https://www.trustpilot.com/review/bymatautomation.com?',
    google: 'https://g.page/r/Cbr3bpg_ygF0EAI/review',
    googleSearch: 'https://www.google.com/search?q=bymat+automation',
  },
};

export const HERO_STATS = [
  { label: 'Years Industry Experience', value: '18+', suffix: '' },
  { label: 'Mission', value: '1', suffix: 'M+' },
  { label: 'Real-Time Projects', value: '50', suffix: '+' },
  { label: 'AI-Powered Mentorship', value: '24/7', suffix: '' },
];

export const EXPERTISE = [
  {
    id: 'selenium',
    title: 'Selenium + Java + Cucumber BDD + GenAI + MCP Server',
    short: 'Industry-grade Selenium framework engineered with Java, BDD layer, and AI-assisted automation patterns.',
    tools: ['Java', 'Selenium 4', 'Cucumber BDD', 'TestNG', 'Maven', 'GitHub Actions', 'GenAI'],
    accent: 'from-cyan-400/30 to-blue-600/20',
  },
  {
    id: 'playwright',
    title: 'Playwright + JavaScript + Cucumber BDD + GenAI + MCP Server',
    short: 'Modern end-to-end testing with Playwright, JavaScript, BDD, and AI test generation workflows.',
    tools: ['JavaScript', 'Playwright', 'Cucumber BDD', 'Node.js', 'Allure', 'CI/CD', 'GenAI'],
    accent: 'from-cyan-300/30 to-indigo-600/20',
  },
  {
    id: 'appium',
    title: 'Appium + Java + Cucumber BDD + GenAI + MCP Server',
    short: 'Cross-platform mobile automation: Android & iOS, real devices, BDD design, and AI-enhanced flows.',
    tools: ['Java', 'Appium 2', 'Cucumber BDD', 'TestNG', 'Android Studio', 'Xcode', 'GenAI'],
    accent: 'from-blue-400/30 to-cyan-500/20',
  },
];

export const PROGRAMS = [
  {
    id: 'selenium',
    title: 'Selenium + Java + Cucumber BDD + GenAI + MCP Server',
    duration: '90 Days',
    mode: 'Live Online + Recordings',
    price: '₹ 14,999',
    payment: 'https://rzp.io/rzp/selenium-ai',
    summary: 'Become a job-ready Selenium Automation Engineer with Java, BDD frameworks, and AI augmentation.',
    outcomes: [
      'Build production-grade Selenium framework from scratch',
      'Implement Cucumber BDD with reusable step definitions',
      'Integrate GenAI for self-healing locators & test generation',
      'Cracking interviews for SDET / Automation Architect roles',
    ],
    aiIntegrations: ['Self-healing locators', 'AI test case generation', 'Smart bug triage', 'Prompt-driven script authoring'],
    careers: ['Automation QA', 'SDET', 'QA Architect', 'Test Lead'],
    bonuses: ['Real-time project source code', 'Interview Q&A bank (500+)', '1:1 mentorship calls', 'Resume + LinkedIn rebuild'],
    curriculum: [
      { module: 'Core Java Foundations', topics: ['OOPs deep dive', 'Collections & Streams', 'Exception handling', 'File IO & JSON'] },
      { module: 'Selenium WebDriver 4', topics: ['Locators & Waits', 'Actions, Frames, Windows', 'Page Object Model', 'Page Factory + Decorators'] },
      { module: 'TestNG + Cucumber BDD', topics: ['Annotations, Listeners', 'Data Driven Testing', 'Cucumber Gherkin syntax', 'Hooks & Tags'] },
      { module: 'Framework Architecture', topics: ['Hybrid Framework design', 'Config + Properties layer', 'Logging (Log4j)', 'Reporting (Extent + Allure)'] },
      { module: 'GenAI Integration', topics: ['AI test generation patterns', 'Self-healing locators', 'AI-assisted debugging', 'Prompt engineering for QA'] },
      { module: 'CI/CD & DevOps', topics: ['GitHub Actions pipelines', 'Docker for Selenium Grid', 'Jenkins integration', 'Cloud reporting'] },
      { module: 'Capstone Project', topics: ['Real-world e-commerce automation', 'Banking domain automation', 'Performance smoke tests', 'Code review session'] },
    ],
  },
  {
    id: 'playwright',
    title: 'Playwright + JavaScript + Cucumber BDD + GenAI + MCP Server',
    duration: '90 Days',
    mode: 'Live Online + Recordings',
    price: '₹ 14,999',
    payment: 'https://rzp.io/rzp/playwright-ai',
    summary: 'Master next-generation Playwright automation with JavaScript, BDD, and AI workflows.',
    outcomes: [
      'Design Playwright framework with TypeScript optionality',
      'Implement Cucumber BDD with Playwright Test Runner',
      'Leverage AI for codeless test generation',
      'API + UI + Mobile web automation in one stack',
    ],
    aiIntegrations: ['Playwright Codegen + AI', 'Auto-wait strategies', 'AI flake detection', 'Test prompting'],
    careers: ['Playwright SDET', 'Full-Stack QA Engineer', 'Test Automation Architect'],
    bonuses: ['GitHub portfolio project', 'Cypress vs Playwright comparison kit', 'API testing bundle', '1:1 mock interviews'],
    curriculum: [
      { module: 'JavaScript Essentials', topics: ['ES6+ syntax', 'Async / Await / Promises', 'Modules & npm', 'Functional patterns'] },
      { module: 'Playwright Deep Dive', topics: ['Browser contexts', 'Auto-waits & retries', 'Network interception', 'Visual + accessibility testing'] },
      { module: 'Cucumber BDD with Playwright', topics: ['Gherkin scenarios', 'World object pattern', 'Hooks & data tables', 'Tag-driven runs'] },
      { module: 'Framework Engineering', topics: ['Folder structure', 'Config management', 'Custom reporters', 'Allure integration'] },
      { module: 'AI Augmentation', topics: ['AI codegen workflows', 'Self-healing UI tests', 'LLM-driven assertions', 'Prompt libraries'] },
      { module: 'CI/CD', topics: ['GitHub Actions matrix', 'Docker runners', 'Parallel sharding', 'Slack notifications'] },
      { module: 'Capstone Project', topics: ['SaaS dashboard automation', 'E-commerce checkout flows', 'API + UI integration', 'Live demo'] },
    ],
  },
  {
    id: 'appium',
    title: 'Appium + Java + Cucumber BDD + GenAI + MCP Server',
    duration: '90 Days',
    mode: 'Live Online + Recordings',
    price: '₹ 14,999',
    payment: 'https://rzp.io/rzp/appium-ai',
    summary: 'Career-defining mobile automation for Android + iOS using Appium 2, Java BDD, and AI flows.',
    outcomes: [
      'Mobile test automation for Android + iOS real devices',
      'Hybrid Appium framework with Cucumber BDD',
      'AI-driven element identification',
      'Cloud device farm integrations (BrowserStack, SauceLabs)',
    ],
    aiIntegrations: ['AI element finder', 'Smart gestures', 'AI visual diff', 'Test scenario generation'],
    careers: ['Mobile Automation Engineer', 'Mobile SDET', 'QA Architect'],
    bonuses: ['Sample app source code', 'iOS provisioning guide', 'Cloud farm setup', 'Mobile interview kit'],
    curriculum: [
      { module: 'Mobile Testing Foundations', topics: ['Android architecture', 'iOS architecture', 'ADB & instruments', 'Emulator vs real device'] },
      { module: 'Java for Appium', topics: ['Core Java', 'OOPs & Collections', 'Maven', 'Streams'] },
      { module: 'Appium 2 Deep Dive', topics: ['Drivers & plugins', 'Locators (UIAutomator2, XCUITest)', 'Gestures W3C', 'WebView automation'] },
      { module: 'Cucumber BDD', topics: ['Gherkin', 'Hooks', 'Step definitions', 'Reusable POM layers'] },
      { module: 'Framework Engineering', topics: ['Capabilities management', 'Logging & reporting', 'Test data layer', 'Allure reports'] },
      { module: 'AI Integration', topics: ['AI element heuristics', 'Self-healing for mobile', 'Visual assertion AI', 'Prompt patterns'] },
      { module: 'Cloud Device Farms', topics: ['BrowserStack', 'SauceLabs', 'AWS Device Farm', 'CI integration'] },
      { module: 'Capstone Project', topics: ['Banking mobile app', 'E-commerce app', 'Real device demo', 'Code review'] },
    ],
  },
];

export const BOOKS = [
  {
    title: 'Selenium Mastery with Java',
    subtitle: 'From Beginner to Architect',
    coverUrl: 'https://images.unsplash.com/photo-1532012197267-da84d127e765?auto=format&fit=crop&w=600&q=80',
    type: 'Paperback + eBook',
    cta: 'Download',
  },
  {
    title: 'Cucumber BDD Blueprint',
    subtitle: 'Step-by-Step Framework Design',
    coverUrl: 'https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?auto=format&fit=crop&w=600&q=80',
    type: 'Paperback + eBook',
    cta: 'Download',
  },
  {
    title: 'GenAI for QA Engineers',
    subtitle: 'Practical Automation Workflows',
    coverUrl: 'https://images.unsplash.com/photo-1495446815901-a7297e633e8d?auto=format&fit=crop&w=600&q=80',
    type: 'eBook (PDF)',
    cta: 'Download',
  },
  {
    title: 'Interview Question Bank',
    subtitle: '500+ SDET interview Q&A',
    coverUrl: 'https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?auto=format&fit=crop&w=600&q=80',
    type: 'Free PDF',
    cta: 'Download',
  },
];

export const VIDEO_TESTIMONIALS = [
  { id: 'v1', name: 'Shital', role: 'Manual to Automation QA', thumb: '/thumbnails/V1_thumbnail_Shital.png', video: 'https://iframe.mediadelivery.net/embed/677801/4941f995-2e3d-4563-842b-1c26a0a15146?autoplay=true&muted=false', quote: 'Within just 3 months, I successfully transitioned from Manual to Selenium Automation QA role and secured my job.' },
  { id: 'v2', name: 'Shivam', role: 'Manual to Automation QA @TCS', thumb: '/thumbnails/V2_thumbnail_Shivam.png', video: 'https://iframe.mediadelivery.net/embed/677801/48364bc4-8e8d-40d0-b560-4da39b64419c?autoplay=true&muted=false', quote: 'Rahul sir\'s real-time projects gave me confidence to complete my project work.' },
  { id: 'v3', name: 'Shivam', role: 'Manual to Automation QA @TCS', thumb: '/thumbnails/V3_thumbnail_Shivam.png', video: 'https://iframe.mediadelivery.net/embed/677801/ae76027b-d5a2-4578-a9af-7083cdb56e9a?autoplay=true&muted=false', quote: 'I am very happy with the mentorship and guidance provided by Rahul sir. I have learned a lot from the course and it has helped me in my career growth.' },
  { id: 'v4', name: 'Akshay', role: 'Manual to Automation QA @Infosys', thumb: '/thumbnails/V4_thumbnail_Akshay.png', video: 'https://iframe.mediadelivery.net/embed/677801/52d57921-1404-4afb-ad46-f8985286ba44?autoplay=true&muted=false', quote: 'Real industry use cases, not theory.' },
];

export const REVIEWS = {
  urbanpro: [
    //{ name: 'Saurabh P.', stars: 5, text: 'Rahul sir explains automation concepts with clarity and real industry context. Best Selenium trainer in Pune.', date: 'Jan 2026', role: 'QA Engineer' },
    { name: 'Bhumi K.', stars: 5, text: "Very happy with Rahul Sir's style of teaching.He explained things clearly and made them easy to understand and best part is recording is available for all sessions. Sir makes the code easy to understand, he simplified whole learning experience. Someone who has zero knowledge in automation testing and coding can easily understandable."},
    { name: 'Vidya T.', stars: 5, text: 'Excellent BDD training. I implemented the framework on day one at my workplace.', date: 'Dec 2025', role: 'SDET' },
    { name: 'Aman J.', stars: 5, text: 'Job-oriented training. Got placed within 2 months of completion.', date: 'Nov 2025', role: 'Automation QA' },
    { name: 'Sneha R.', stars: 5, text: 'The AI integration modules are gold. Saved hours of script writing.', date: 'Nov 2025', role: 'QA Lead' },
    { name: 'Karan D.', stars: 5, text: 'Real-time projects, 1:1 mentorship, and interview prep — full package.', date: 'Oct 2025', role: 'SDET II' },
    { name: 'Pranita S.', stars: 5, text: 'Playwright training was hands-on. Highly recommend for QA professionals.', date: 'Oct 2025', role: 'Playwright SDET' },
    { name: 'Manoj V.', stars: 5, text: 'Appium course covered real iOS + Android with cloud farms. Outstanding.', date: 'Sep 2025', role: 'Mobile Automation Eng.' },
  ],
  trustpilot: [
    { name: 'Anil G.', stars: 5, text: 'BYMAT Automation delivered exactly what was promised. 5/5.', date: 'Jan 2026', role: 'QA Engineer' },
    { name: 'Mehak K.', stars: 5, text: 'Mentor is patient and explains AI concepts with industry examples.', date: 'Dec 2025', role: 'SDET' },
    { name: 'Rajesh P.', stars: 5, text: 'Career transformation in 90 days. Got a 80% salary hike.', date: 'Dec 2025', role: 'Automation Lead' },
    { name: 'Divya N.', stars: 5, text: 'Premium quality training with real-time projects. Worth every rupee.', date: 'Nov 2025', role: 'Senior QA' },
    { name: 'Suresh L.', stars: 5, text: 'Best Playwright + AI course in India. Hands down.', date: 'Nov 2025', role: 'Playwright Eng.' },
    { name: 'Shweta A.', stars: 5, text: 'Mobile automation with Appium 2 — modern, relevant, well-structured.', date: 'Oct 2025', role: 'Mobile QA' },
    { name: 'Vikram H.', stars: 5, text: 'The GenAI Automation module makes you future-proof. Loved it.', date: 'Oct 2025', role: 'AI QA Eng.' },
  ],
};

export const GALLERY_IMAGES = [
  // Mentor photos
  { url: 'https://customer-assets.emergentagent.com/job_bymat-lms-portal/artifacts/vfuxp02z_1.jpg', cat: 'awards', caption: 'Rahul Ganjare — Founder & Lead Mentor' },
  { url: 'https://customer-assets.emergentagent.com/job_bymat-lms-portal/artifacts/ur33whnn_2.JPG', cat: 'events', caption: 'Mentor Journey — Autumn 2024' },
  { url: 'https://customer-assets.emergentagent.com/job_bymat-lms-portal/artifacts/yn5xt4tx_3.JPG', cat: 'events', caption: 'On-site Workshop — Weymouth UK' },
  { url: 'https://customer-assets.emergentagent.com/job_bymat-lms-portal/artifacts/pp52p6ec_4.JPG', cat: 'events', caption: 'Strategy Retreat — Durdle Door' },
  { url: 'https://customer-assets.emergentagent.com/job_bymat-lms-portal/artifacts/0qxvqa55_5.JPG', cat: 'events', caption: 'Industry Visit — Tower Bridge London' },
  // Stock workshop / training imagery
  { url: '/images/Interview_01.png', cat: 'events', caption: 'Live Automation Workshop — Pune' },
  { url: '/images/Interview_02.png', cat: 'events', caption: 'Live Automation Workshop — Pune' },
  { url: '/images/Interview_04.png', cat: 'events', caption: 'Live Automation Workshop — Pune' },
  //{ url: '/images/Interview_05.png', cat: 'events', caption: 'Live Automation Workshop — Pune' },
  //{ url: 'https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&w=900&q=80', cat: 'workshops', caption: 'Live Automation Workshop — Pune' },
  // { url: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?auto=format&fit=crop&w=900&q=80', cat: 'workshops', caption: 'Corporate Training Session' },
  // { url: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?auto=format&fit=crop&w=900&q=80', cat: 'workshops', caption: 'Corporate Training Session' },
  { url: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&w=900&q=80', cat: 'corporate', caption: 'Enterprise Automation Bootcamp' },
  { url: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=900&q=80', cat: 'corporate', caption: 'Client Strategy Meeting' },
  { url: 'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=900&q=80', cat: 'workshops', caption: 'Hands-on Coding Lab' },
  { url: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=900&q=80', cat: 'workshops', caption: 'Project Review Session' },
  { url: 'https://images.unsplash.com/photo-1543269865-cbf427effbad?auto=format&fit=crop&w=900&q=80', cat: 'events', caption: 'Student Graduation Day' },
  { url: 'https://images.unsplash.com/photo-1559223607-a43c990c692c?auto=format&fit=crop&w=900&q=80', cat: 'awards', caption: 'Excellence in Training Award' },
  { url: 'https://images.unsplash.com/photo-1532619675605-1ede6c2ed2b0?auto=format&fit=crop&w=900&q=80', cat: 'workshops', caption: 'AI Automation Bootcamp' },
];

export const FAQ = [
  { q: 'Do I need coding background to join?', a: 'No. We start from Core Java / JavaScript fundamentals. If you have manual testing experience, you are perfectly placed.' },
  { q: 'Are sessions live or recorded?', a: 'Both. Live mentor-led sessions with lifetime access to recordings on the Learning Hub.' },
  { q: 'Will I get a certificate?', a: 'Yes. Upon completion and feedback verification, BYMAT Automation issues a course completion certificate.' },
  { q: 'Is there job assistance?', a: 'Yes — resume rebuild, LinkedIn optimisation, mock interviews, and active referral support.' },
  { q: 'What if I miss a class?', a: 'All sessions are recorded and available securely on the Learning Hub portal for your batch.' },
];

// ---- LMS MOCK DATA ----
export const MOCK_BATCHES = [
  { id: 'b1', name: 'Selenium AI — Batch S26', course: 'Selenium + Java + Cucumber BDD + AI', startDate: '2026-02-10', students: 38, status: 'Active' },
  { id: 'b2', name: 'Playwright AI — Batch P14', course: 'Playwright + JS + Cucumber BDD + AI', startDate: '2026-02-18', students: 27, status: 'Active' },
  { id: 'b3', name: 'Appium AI — Batch A09', course: 'Appium + Java + Cucumber BDD + AI', startDate: '2026-03-01', students: 19, status: 'Upcoming' },
];

export const MOCK_VIDEOS = [
  { id: 'v1', title: 'Session 01 — Selenium WebDriver Architecture', batch: 'b1', duration: '1h 22m', date: '2026-02-10', thumb: 'https://images.unsplash.com/photo-1542831371-29b0f74f9713?auto=format&fit=crop&w=600&q=80', progress: 78 },
  { id: 'v2', title: 'Session 02 — Locators Deep Dive + AI Healing', batch: 'b1', duration: '1h 45m', date: '2026-02-12', thumb: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&w=600&q=80', progress: 40 },
  { id: 'v3', title: 'Session 03 — Page Object Model with Decorators', batch: 'b1', duration: '1h 30m', date: '2026-02-14', thumb: 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?auto=format&fit=crop&w=600&q=80', progress: 0 },
  { id: 'v4', title: 'Session 04 — Cucumber BDD Step Definitions', batch: 'b1', duration: '1h 50m', date: '2026-02-16', thumb: 'https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=600&q=80', progress: 0 },
  { id: 'v5', title: 'Session 05 — Framework Architecture', batch: 'b1', duration: '2h 10m', date: '2026-02-18', thumb: 'https://images.unsplash.com/photo-1581291518857-4e27b48ff24e?auto=format&fit=crop&w=600&q=80', progress: 0 },
  { id: 'v6', title: 'Session 06 — GenAI Test Generation Workflow', batch: 'b1', duration: '1h 38m', date: '2026-02-20', thumb: 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?auto=format&fit=crop&w=600&q=80', progress: 0 },
];

export const MOCK_RESOURCES = [
  { id: 'r1', title: 'Selenium Framework Source Code (ZIP)', type: 'ZIP', size: '12.4 MB', date: '2026-02-10', batch: 'b1', allowed: true },
  { id: 'r2', title: 'Java Interview Q&A — 500 Questions', type: 'PDF', size: '4.8 MB', date: '2026-02-10', batch: 'b1', allowed: true },
  { id: 'r3', title: 'Cucumber BDD Cheatsheet', type: 'PDF', size: '0.9 MB', date: '2026-02-12', batch: 'b1', allowed: true },
  { id: 'r4', title: 'Resume Template — SDET', type: 'DOCX', size: '0.4 MB', date: '2026-02-12', batch: 'b1', allowed: true },
  { id: 'r5', title: 'AI Prompt Library for QA', type: 'PDF', size: '1.2 MB', date: '2026-02-14', batch: 'b1', allowed: false },
];

export const MOCK_STUDENT = {
  name: 'Rohit Sharma',
  email: 'rohit.sharma@example.com',
  phone: '+91-98765 43210',
  batch: 'b1',
  batchName: 'Selenium AI — Batch S26',
  enrolledOn: '2026-01-25',
  progress: 27,
};

export const MENTOR_TIMELINE = [
  { year: '2007', title: 'Started QA career', desc: 'Began as Manual Tester at a Pune-based services company.' },
  { year: '2011', title: 'Automation pivot', desc: 'Mastered Selenium WebDriver + Java; led automation initiatives.' },
  { year: '2015', title: 'Framework Architect', desc: 'Designed enterprise BDD frameworks for global banking clients.' },
  { year: '2018', title: 'Founded BYMAT Automation', desc: 'Mission: transform 1M IT professionals with industry-ready training.' },
  { year: '2022', title: 'Playwright + Mobile expansion', desc: 'Added Playwright + Appium specializations to curriculum.' },
  { year: '2024', title: 'GenAI Automation', desc: 'Pioneered AI-augmented automation testing modules.' },
  { year: '2026', title: '1M Mission scaling', desc: 'Global cohort delivery + Learning Hub LMS launch.' },
];
